import { Flex, Greyscale, Typography } from 'glints-aries';
import styled from 'styled-components';

const { Paragraph, Title: AriesTitle } = Typography;

export const Title = styled(AriesTitle).attrs({ tag: 'h3' })`
  margin-top: 25px;
  font-weight: 700;
  color: ${Greyscale.devilsgrey};
  font-size: 20px;
`;

export const Description = styled(Paragraph).attrs({ variant: 'caption' })`
  margin-top: 15px;
  color: ${Greyscale.devilsgrey};
`;

export const JobInReviewContainer = styled(Flex)`
  min-height: 80vh;
  text-align: center;
`;
